export enum FTNAV_EVENT {
  OPENED = "ftnav.global-navigation.opened",
  CLOSE = "ftnav.global-navigation.close",
}
